var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalken48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_2309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 34.5001C17.2495 34.5001 18.47 34.3796 19.6501 34.1499C20.4272 35.5153 21.3925 36.7577 22.5111 37.8431C23.8769 39.1683 25.4711 40.2593 27.2291 41.0514C25.6169 45.1215 21.6446 48.0001 17 48.0001C10.9249 48.0001 6 43.0753 6 37.0001C6 35.3051 6.38339 33.6996 7.0682 32.2656C9.7166 33.6903 12.7611 34.5001 16 34.5001Z",
    fill: "#F47B04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9999 12C36.1483 12 38.1837 12.4839 40.003 13.3487C44.7312 15.5963 47.9999 20.4164 47.9999 26C47.9999 33.732 41.7319 40 33.9999 40C30.2103 40 26.7724 38.4943 24.2518 36.0486C23.4584 35.2788 22.7559 34.4158 22.1619 33.4774C29.3495 31.0079 34.4999 24.3392 34.4999 16.5C34.4999 14.9464 34.2976 13.4388 33.9173 12.0008L33.9999 12Z",
    fill: "#FF9900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FFB82F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 14V17.6C15.9999 19.1464 14.7463 20.4 13.1999 20.4C11.6535 20.4 10.3999 19.1464 10.3999 17.6V15.6",
    stroke: "#FFF2C3",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 12.3999V17.5999C21.6 19.1463 20.3464 20.3999 18.8 20.3999C17.2536 20.3999 16 19.1463 16 17.5999V13.9999",
    stroke: "#FFF2C3",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
    stroke: "#FFF2C3",
    strokeWidth: 2.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_2309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalken48);
export default __webpack_public_path__ + "static/media/walken48.86793304e315304ed1e7d60f6677d133.svg";
export { ForwardRef as ReactComponent };